<app-view-item *ngIf="disabled" [text]="displayText" [borderless]="borderless"></app-view-item>

<nz-select *ngIf="!disabled" nz-input [(ngModel)]="value" [nzDropdownMatchSelectWidth]="false"
  (ngModelChange)="onModelChange($event)" nzAllowClear="true" [nzShowSearch]="true">
  <nz-option [nzValue]="item.value" [nzLabel]="item.name" *ngFor="let item of options"></nz-option>
</nz-select>